import { render, staticRenderFns } from "./trip-edit.vue?vue&type=template&id=5755c2c8&"
import script from "./trip-edit.vue?vue&type=script&lang=js&"
export * from "./trip-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports